import React from "react";
import { portfolioData as DATA } from "../../data/portfolioData";
import Card from "../ui/Card";
import SectionTitle from "../ui/SectionTitle";

export default function Contact() {
  return (
    <div className="mx-auto max-w-6xl px-4 py-14" id="contact">
      <SectionTitle kicker="Let’s talk" title="Contact" />

      <Card className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div>
          <div className="text-lg font-semibold text-white">{DATA.name}</div>
          <div className="mt-1 text-sm text-white/70">{DATA.title}</div>

          <div className="mt-3 flex flex-wrap gap-4 text-sm text-white/70">
            <span>📧 {DATA.email}</span>
          </div>
        </div>

        <div className="flex flex-wrap gap-3">
          <a
            href={`mailto:${DATA.email}`}
            className="rounded-xl bg-indigo-500 px-4 py-2.5 text-sm font-semibold text-white shadow-glow hover:bg-indigo-400"
          >
            Email Me
          </a>
          <a
            href="#projects"
            className="rounded-xl border border-white/10 bg-white/5 px-4 py-2.5 text-sm font-semibold text-white hover:bg-white/10"
          >
            View Projects
          </a>
        </div>
      </Card>

      <div className="mt-8 text-center text-xs text-white/50">
        © {new Date().getFullYear()} {DATA.name}.
      </div>
    </div>
  );
}
